import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueMeta from 'vue-meta'
import mixin from '@/common/mixin'
import verifyClick from '@/directives/verifyClick'

Vue.use(ElementUI)
// 启用 vue-meta，支持在路由 meta 中动态管理 title/description/keywords/canonical
// ssrAttribute: 预渲染时把 meta 信息渲染到 HTML 中
Vue.use(VueMeta, {
  keyName: 'head',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid'
})
Vue.mixin(mixin)
Vue.directive('verify-click', verifyClick)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
